// 获取页面参数
export function queryURLParams(url) {
    let pattern = /(\w+)=(\w+)/gi; //定义正则表达式

    let parames = {}; // 定义参数对象

    url.replace(pattern, ($, $1, $2) => {
        parames[$1] = $2;
    });

    return parames;
}

// 下载图片
export function downloadFile(fileUrl, fileName = '未知文件') {
    const el = document.createElement('a');
    el.style.display = 'none';
    el.setAttribute('target', '_blank');
    /**
          * download的属性是HTML5新增的属性
          * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
          * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
          * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
          */
    fileName && el.setAttribute('download', fileName);
    el.href = fileUrl;
    console.log(el);
    document.body.appendChild(el);
    el.click();
    document.body.removeChild(el);
}

// 判断是苹果系统(ios)还是安卓系统(Android)
export function checkPlatform() {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    if (/android/i.test(navigator.userAgent)) {
        return 'Android'
    }
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return "iOS"
    }
}

// 判断元素父集是否有已定位元素
export function getOffsetTop(ele) {
    var rtn = ele.offsetTop;
    var o = ele.offsetParent;
    while (o != null) {
        rtn += o.offsetTop;
        o = o.offsetParent;
    }
    return rtn;
}

//实现滚动条滚到相应高度触发动画的操作
export function gdjz(div, callback) {
    let dom = this.$refs[div];
    if (dom) {
        var scrollTop =
            document.documentElement.scrollTop || document.body.scrollTop;
        var windowHeight = document.documentElement.clientHeight; // 浏览器可视区域高度
        var curh = windowHeight + scrollTop;
        var cccurh = this.getOffsetTop(dom);
        var cch = dom.offsetHeight;

        if (curh - cccurh > 10 && curh - cccurh < cch) {
            // console.log("已滚动到区域: ");
            callback && callback();
        }
    }
}

// 获取屏幕高度
export function clientHeight() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    return h;
}

// 锚点跳转
export function scrollIntoView(id) {
    document.getElementById(id).scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth",
        alignTo: false,
    });
}